import { getCookieValue } from "@/lib/language";

export const DEFAULT_TIMEZONE = "America/New_York";

export function normalizeTimezone(value: string | null | undefined): string {
  if (!value) return DEFAULT_TIMEZONE;

  try {
    new Intl.DateTimeFormat("en-US", { timeZone: value }).format(new Date());
    return value;
  } catch {
    return DEFAULT_TIMEZONE;
  }
}

export function getInitialTimezone(): string {
  const userTimezone = getCookieValue("user_timezone");
  if (userTimezone) {
    return normalizeTimezone(userTimezone);
  }

  return normalizeTimezone(getCookieValue("tenant_default_timezone"));
}

export function formatDateWithTimezone(
  date: string | Date,
  options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  },
  locale = "en-US"
): string {
  const dateObj = typeof date === "string" ? new Date(date) : date;

  if (Number.isNaN(dateObj.getTime())) {
    return "Invalid date";
  }

  return new Intl.DateTimeFormat(locale, {
    timeZone: getInitialTimezone(),
    ...options,
  }).format(dateObj);
}

export function getTimezoneDateKey(date: string | Date): string {
  const dateObj = typeof date === "string" ? new Date(date) : date;

  if (Number.isNaN(dateObj.getTime())) {
    return "";
  }

  return new Intl.DateTimeFormat("en-CA", {
    timeZone: getInitialTimezone(),
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(dateObj);
}
